import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { useI18N } from "@src/language/language-context";
import { RootState } from "@src/reducers/store";

export const useNewInitialFilterModalHook = () => {
  const i18n = useI18N();
  const logger = getLogger();
  const texts = {
    filterSubtitle: i18n("modules.initialStructureFilter.subtitle"),
    labelText: i18n("modules.initialStructureFilter.labelText"),
    textAreaPlaceholder: i18n(
      "modules.initialStructureFilter.textAreaPlaceholder",
    ),
    showResults: i18n("modules.initialStructureFilter.showResults"),
    clearFilter: i18n("modules.initialStructureFilter.clearFilter"),
  };

  const filterInputContent = useSelector(
    (state: RootState) => state.yourSlice.initialFilterModal.filterInputContent,
  );

  const [localFilterInputContent, setLocalFilterInputContent] = useState("");

  const nodeManager = getNodeManager();

  const handlecloseModal = (): void => {
    logger.debug("useNewInitialFilterModalHook", {
      function: "handlecloseModal",
    });
    nodeManager.closeInitialStructureFilterModal();
  };

  const handleShowResultsClick = () => {
    logger.debug("useNewInitialFilterModalHook", {
      function: "handleShowResultsClick",
    });
    nodeManager.handleShowResultsClickInInitialFilterModal(
      localFilterInputContent,
    );
  };

  const handleClearFilterClick = () => {
    logger.debug("useNewInitialFilterModalHook", {
      function: "handleClearFilterClick",
    });
  };

  useEffect(() => {
    setLocalFilterInputContent(filterInputContent || "");
  }, []);

  return {
    handlecloseModal: handlecloseModal,
    handleShowResultsClick: handleShowResultsClick,
    handleClearFilterClick: handleClearFilterClick,
    setLocalFilterInputContent: setLocalFilterInputContent,
    localFilterInputContent: localFilterInputContent,
    texts: texts,
  };
};
